var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var loaders = require('../../layout/components/loaders');
var dragscroll = require('../../libs/dragscroll');
var rangePikaday = require('../../libs/rangePikaday');

var dateFormat = 'MM-DD-YYYY hh:mm:ss a';
var dateFormatQueryParams = 'MM-DD-YYYY';

var unitMap = {
  'tempF': '°F',
  'tempC': '°C',
  'temp-F': '°F',
  'temp-C': '°C',
  'degF': '°F',
  'degC': '°C',
  'percent': '%',
  'inH2O': 'wc',
  'int': '',
  'str': '',
  'datetime': '',
  'gal/min': 'gpm'
};

function formatStatus(value) {
  if (typeof value === 'undefined' || value === null || value === '') return '---';
  return String(value).replace(/(^|[\s_-])([a-z])/g, function (_match, prefix, letter) {
    return prefix + letter.toUpperCase();
  });
}

function requestErrorMessage(err) {
  return err && (err.message || err.response &&
    (err.response.message || err.response.error)) || 'Failed to load events';
}

function createHistoryState(options, target) {
  var state = target || {};
  state.pointRid = options.pointRid;
  state.pointUnit = options.pointUnit;
  state.pageSize = options.pageSize || 50;
  state.records = prop([]);
  state.error = prop(null);
  state.dates = prop(options.dates);
  state.loading = false;
  state.page = 1;
  state.pageCursors = [null];
  state.hasNext = false;
  state.requestVersion = 0;

  state.loadPage = function (page) {
    var targetPage = Math.max(1, Number(page) || 1);
    var cursor = state.pageCursors[targetPage - 1];
    if (targetPage > 1 && !cursor) return Promise.resolve();

    var requestVersion = ++state.requestVersion;
    var params = {
      pointRid: state.pointRid,
      start: state.dates()[0].valueOf(),
      end: state.dates()[1].valueOf(),
      limit: state.pageSize
    };
    if (cursor) {
      params.beforeTimestamp = cursor.timestamp;
      params.beforeRid = cursor.rid;
    }

    state.error(null);
    state.loading = true;
    return loaders.requestWithLoader({
      url: '/api/v1/events/point-command-history',
      method: 'GET',
      params: params
    })
      .then(function (response) {
        if (requestVersion !== state.requestVersion) return;
        response = response || {};
        state.records(Array.isArray(response.records) ? response.records : []);
        state.page = targetPage;
        state.hasNext = response.hasNext === true && !!response.nextCursor;
        state.pageCursors = state.pageCursors.slice(0, targetPage);
        if (state.hasNext) state.pageCursors[targetPage] = response.nextCursor;
      })
      .catch(function (err) {
        if (requestVersion !== state.requestVersion) return;
        state.records([]);
        state.hasNext = false;
        state.error(requestErrorMessage(err));
      })
      .finally(function () {
        if (requestVersion !== state.requestVersion) return;
        state.loading = false;
        m.redraw();
      });
  };

  state.resetAndLoad = function () {
    state.page = 1;
    state.pageCursors = [null];
    state.hasNext = false;
    return state.loadPage(1);
  };
  state.previousPage = function () {
    if (!state.loading && state.page > 1) return state.loadPage(state.page - 1);
  };
  state.nextPage = function () {
    if (!state.loading && state.hasNext) return state.loadPage(state.page + 1);
  };
  state.retry = function () {
    return state.loadPage(state.page);
  };

  return state;
}

function commandTable(rows) {
  return m('div.overflow-hidden.mb3', [
    m('div.dragscroll-container', { style: { 'margin-right': '0px' } }, [
      m('div.dragscroll', { oncreate: dragscroll }, [
        m('table.pb3.narrow.w-100', [
          m('tbody', [
            m('tr', [
              m('td.bb.tl.nowrap.pr3.overflow-hidden.f3.fw4', 'Timestamp'),
              m('td.bb.tl.nowrap.pr3.overflow-hidden.f3.fw4', 'Name/Action'),
              m('td.bb.tl.nowrap.pr3.overflow-hidden.f3.fw4', 'Value'),
              m('td.bb.tl.nowrap.pr3.overflow-hidden.f3.fw4', 'Status'),
              m('td.bb.tl.nowrap.pr3.overflow-hidden.f3.fw4', 'Type'),
              m('td.bb.tl.nowrap.pr3.overflow-hidden.f3.fw4', 'User')
            ]),
            rows
          ])
        ])
      ])
    ])
  ]);
}

function skeletonTable(ctrl) {
  var rows = [];
  for (var row = 0; row < ctrl.pageSize; row += 1) {
    rows.push(m('tr', [50, 70, 50, 40, 45, 45].map(function (width) {
      return m('td.bb.bl-0.pr2.skeleton', [
        m('div.f4.br2.bg-dark-gray.o-20', { style: { height: '1em', width: width + '%' } })
      ]);
    })));
  }
  return commandTable(rows);
}

function formatValue(rawValue) {
  if (typeof rawValue === 'undefined' || rawValue === null || rawValue === '') return '---';
  if (Array.isArray(rawValue)) {
    return rawValue.map(function (value) {
      var number = parseFloat(value);
      return Number.isNaN(number) ? String(value) : number.toFixed(2);
    }).join(', ');
  }
  var number = parseFloat(rawValue);
  return Number.isNaN(number) ? String(rawValue) : number.toFixed(2);
}

function valueCell(eventRecord, pointUnit) {
  var formattedValue = formatValue(eventRecord.properties && eventRecord.properties.value);
  var baseUnit = pointUnit || eventRecord.object && eventRecord.object.unit;
  var unit = baseUnit ? unitMap[baseUnit] || baseUnit : '';
  if (formattedValue === '---' || !unit || unit === '---') return formattedValue;
  return m('span', [
    formattedValue,
    m('span.v-top.dib.moon-gray', { style: { fontSize: '10px' } }, ' ' + unit)
  ]);
}

function eventRow(eventRecord, pointUnit) {
  var properties = eventRecord.properties || {};
  var execState = properties.exec && properties.exec.state;
  var status = typeof properties.active !== 'undefined'
    ? (Number(properties.active) === 1 ? 'Activated' : 'Released')
    : formatStatus(execState);
  var user = properties.firstName || properties.lastName
    ? (properties.firstName || '') + ' ' + (properties.lastName || '')
    : eventRecord.user && (eventRecord.user.firstName || eventRecord.user.lastName)
      ? (eventRecord.user.firstName || '') + ' ' + (eventRecord.user.lastName || '')
      : '';
  var nameAction = eventRecord.object && eventRecord.object.name ||
    eventRecord.type || eventRecord['@class'] || '';

  return m('tr', [
    m('td.pr2.bb.bl-0.truncate.f3.fw2', eventRecord.timestamp
      ? moment(eventRecord.timestamp).format(dateFormat) : ''),
    m('td.pr2.bb.bl-0.truncate.f3.fw2', nameAction),
    m('td.pr2.bb.bl-0.truncate.f3.fw2', valueCell(eventRecord, pointUnit)),
    m('td.pr2.bb.bl-0.truncate.f3.fw2', status),
    m('td.pr2.bb.bl-0.truncate.f3.fw2', eventRecord['@class']),
    m('td.pr2.bb.bl-0.truncate.f3.fw2', user.trim())
  ]);
}

function paginationButton(label, disabled, onclick) {
  return m('button.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.mb1', {
    type: 'button',
    disabled: disabled,
    class: disabled ? 'o-50' : 'pointer',
    onclick: onclick
  }, label);
}

var component = {};

component.oninit = function (vnode) {
  var end = moment();
  var start = moment(end).subtract(365, 'days');
  createHistoryState({
    pointRid: vnode.attrs.pointRid,
    pointUnit: vnode.attrs.pointUnit,
    pageSize: vnode.attrs.pageSize,
    dates: [start, end]
  }, this);
  this.loadPage(1);
};

component.view = function () {
  var ctrl = this;
  var rangePicker = m('div.flex.pt2.pb3.items-center.flex-wrap', [
    m('div.flex.items-center', [
      m('div.mr2', 'Range'),
      m('div.w5.mr2', [
        m(rangePikaday, {
          value: ctrl.dates,
          dateFormat: 'm/d/Y h:i K',
          updateQueryParams: false,
          format: dateFormatQueryParams,
          updateCallback: ctrl.resetAndLoad
        })
      ])
    ])
  ]);

  if (ctrl.loading && !ctrl.records().length) {
    return m('div', [rangePicker, skeletonTable(ctrl)]);
  }

  if (ctrl.error()) {
    return m('div', [
      rangePicker,
      m('div.pa3.br2.ba.b--light-red.bg-washed-red.dark-red', [
        m('div.mb2', 'Error loading Command events: ' + ctrl.error()),
        m('button.btn.btn-primary', { onclick: ctrl.retry }, 'Retry')
      ])
    ]);
  }

  if (!ctrl.records().length) {
    return m('div', [
      rangePicker,
      m('div.flex.justify-center', [
        m('p.tc.mw7', { style: { color: '#ddd' } }, 'No data was found for the range selected.')
      ])
    ]);
  }

  return m('div', [
    rangePicker,
    commandTable(ctrl.records().map(function (record) {
      return eventRow(record, ctrl.pointUnit);
    })),
    m('div.flex.items-center', [
      paginationButton('Previous', ctrl.loading || ctrl.page <= 1, ctrl.previousPage),
      m('div.ph3.f4', 'Page ' + ctrl.page),
      paginationButton('Next', ctrl.loading || !ctrl.hasNext, ctrl.nextPage)
    ])
  ]);
};

component.__testables = {
  createHistoryState: createHistoryState,
  formatStatus: formatStatus,
  formatValue: formatValue,
  requestErrorMessage: requestErrorMessage
};

module.exports = component;
